import React, { Component } from "react";
import { Button, ButtonGroup } from "reactstrap";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";
import * as actions from "../../actions";
import { usersDataColumns } from "./Components/dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import NewUserModal from "./Components/NewUserModal";
import DeleteUserModal from "./Components/DeleteUserModal";
import ChangePasswordModal from "./Components/ChangePasswordModal";
import { getAuthenticatedEmail } from "../../constants/auth";
import "./Users.css";

class Users extends Component {
  state = {
    passwordUser: null
  };

  componentDidMount() {}

  updateUserProps = payload => {
    this.props.updateUserProps(payload);
  };
  mergeUserProps = payload => {
    this.props.mergeUserProps(payload);
  };
  deleteUserProps = payload => {
    this.props.deleteUserProps(payload);
  };
  deleteUser = userOrIndex => {
    const userRows = this.props.usersReducer.users && this.props.usersReducer.users.data
      ? this.props.usersReducer.users.data
      : [];
    const index =
      typeof userOrIndex === "number"
        ? userOrIndex
        : userRows.findIndex(
            user =>
              user &&
              (user === userOrIndex || String(user.id) === String(userOrIndex.id))
          );
    this.updateUserProps([
      { prop: "deleteUserIndex", value: index },
      { prop: "isDeleteUserModalOpen", value: true }
    ]);
  };
  confirmDeleteUser = () => {
    const { deleteUserIndex, users } = this.props.usersReducer;
    const userRows = users && users.data ? users.data : [];
    const user = deleteUserIndex !== null ? userRows[deleteUserIndex] : null;

    if (user) {
      this.props.deleteUser(user, deleteUserIndex);
    }

    this.updateUserProps([
      { prop: "deleteUserIndex", value: null },
      { prop: "isDeleteUserModalOpen", value: false }
    ]);
  };
  createUsers = users => {
    this.props.createUsers(users);
  };
  changePassword = user => {
    this.setState({ passwordUser: user });
  };
  paginate = (tableState, tableInstance) => {
    let param = {};
    if (tableState.sorted.length !== 0) {
      param.sort_column = tableState.sorted[0].id;
      param.sort_type = tableState.sorted[0].desc ? "desc" : "asc";
    }
    if (tableState.filtered.length !== 0) {
      param.filters = [];
      for (let i = 0; i < tableState.filtered.length; i++) {
        // tableState.filtered[i].id
        param.filters.push({ filter_column: tableState.filtered[i].id, filter_value: tableState.filtered[i].value });
      }
    }
    param.page_size = tableState.pageSize;
    this.props.getUsers("users", tableState.page + 1, param);
  };

  render() {
    const {
      users,
      isUsersTableEditable,
      isUserSaving,
      isNewUserModalOpen,
      newUsers,
      isUserCreating,
      isUsersLoading,
      isDeleteUserModalOpen,
      deleteUserIndex
    } = this.props.usersReducer;
    const userRows = users && users.data ? users.data : [];
    const { last_page } = users;
    const activeUsers = userRows.filter(user => user && parseInt(user.is_active, 10) === 1).length;
    const pendingEdits = userRows.filter(user => user && user.edited).length;
    const deleteUserRecord =
      deleteUserIndex !== null ? userRows[deleteUserIndex] : null;
    const canChangePassword = getAuthenticatedEmail() === "admin@faiz.com";
    return (
      <div className="users-page">
        <NewUserModal
          isOpen={isNewUserModalOpen}
          updateUserProps={this.updateUserProps}
          mergeUserProps={this.mergeUserProps}
          deleteUserProps={this.deleteUserProps}
          createUsers={this.createUsers}
          newUsers={newUsers}
          isUserCreating={isUserCreating}
        />
        <DeleteUserModal
          isOpen={isDeleteUserModalOpen}
          user={deleteUserRecord}
          isDeleting={!!(deleteUserRecord && deleteUserRecord.isDeleting)}
          onCancel={() => {
            this.updateUserProps([
              { prop: "deleteUserIndex", value: null },
              { prop: "isDeleteUserModalOpen", value: false }
            ]);
          }}
          onConfirm={this.confirmDeleteUser}
        />
        <ChangePasswordModal
          isOpen={!!this.state.passwordUser}
          user={this.state.passwordUser}
          onCancel={() => this.setState({ passwordUser: null })}
          onSubmit={this.props.changeUserPassword}
        />

        <div className="users-page__hero">
          <div>
            <div className="users-page__eyebrow">Access Management</div>
            <h1 className="users-page__title">Users</h1>
            <p className="users-page__copy">
              Manage backoffice users, activation status, and profile data from one cleaner admin workspace.
            </p>
          </div>

          <div className="users-page__stats">
            <div className="users-stat">
              <span className="users-stat__value">{userRows.length}</span>
              <span className="users-stat__label">Visible users</span>
            </div>
            <div className="users-stat">
              <span className="users-stat__value">{activeUsers}</span>
              <span className="users-stat__label">Active accounts</span>
            </div>
            <div className="users-stat">
              <span className="users-stat__value">{pendingEdits}</span>
              <span className="users-stat__label">Pending edits</span>
            </div>
          </div>
        </div>

        <div className="users-toolbar">
          <div className="users-toolbar__group">
            <ButtonGroup>
              <Button
                color={"faiz3"}
                onClick={() => {
                  this.updateUserProps([{ prop: "isNewUserModalOpen", value: true }]);
                }}
              >
                <i className={"fa fa-plus"} /> New User
              </Button>
              <Button
                color={"faiz1"}
                onClick={() => {
                  this.props.getUsers("users", 1, {});
                }}
              >
                Refresh
              </Button>
            </ButtonGroup>
          </div>

          <div className="users-toolbar__group">
            <ButtonGroup>
              {isUsersTableEditable ? (
                <Button
                  color={"faiz2"}
                  onClick={() => {
                    this.props.saveUsers(users);
                  }}
                  disabled={isUserSaving}
                >
                  {isUserSaving ? (
                    <>
                      <Spinner size={10} animating={true} color={"white"} />
                      &nbsp;
                    </>
                  ) : null}
                  <i className={"fa fa-floppy-o"} /> Save
                </Button>
              ) : (
                <Button
                  color={"faiz1"}
                  onClick={() => {
                    this.props.updateUserProps([{ prop: "isUsersTableEditable", value: true }]);
                  }}
                  disabled={isUserSaving}
                >
                  <i className={"fa fa-pencil"} /> Edit
                </Button>
              )}
            </ButtonGroup>
          </div>
        </div>

        <div className="users-card">
          <div className="users-card__header">
            <div className="users-card__eyebrow">User Directory</div>
            <h2 className="users-card__title">Accounts</h2>
            <p className="users-card__copy">
              Search and update user records inline, then save only the rows that changed.
            </p>
          </div>

          <div className="users-table-shell">
            <ReactTable
              data={userRows}
              columns={usersDataColumns(
                this.updateUserProps,
                isUsersTableEditable,
                this.deleteUser,
                this.changePassword,
                canChangePassword
              )}
              className="-highlight -striped users-table"
              defaultPageSize={10}
              filterable
              manual
              pages={last_page != null ? last_page : -1}
              onFetchData={this.paginate}
              loading={isUsersLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ usersReducer }) => ({
  usersReducer
});

export default connect(
  mapStateToProps,
  actions
)(Users);
